import React from "react";
import { Field, type FieldRenderProps } from "react-final-form";

interface FieldComponentProps<T = unknown> {
  fieldComponent: (params: {
    onChange: (value: T) => void;
    value: T;
    label?: string;
    [key: string]: unknown;
  }) => React.ReactNode;
  label?: string;
  editData?: any;
  allValues?: any;
  [key: string]: unknown;
}

export class FieldComponent<T = unknown> extends React.Component<
  FieldComponentProps<T>
> {
  state = {};

  render() {
    const props = this.props;

    return (
      <Field
        {...props}
        name={props.name as string}
        render={(fieldProps: FieldRenderProps<T, HTMLElement>) => {
          const { input } = fieldProps;
          const { onChange, value } = input;
          const { label, editData, allValues, ...rest } = this.props;

          return this.props.fieldComponent({
            onChange,
            value,
            label,
            editData,
            allValues,
            ...rest,
          });
        }}
      />
    );
  }
}
